import t from"react";import{CtaCopy as e,TargetUrl as r}from"./styles.js";const l=({target_url:l,cta_copy:a})=>t.createElement(t.Fragment,null,a&&t.createElement(e,{variant:"body1",color:"white"},a),t.createElement(r,{href:l.href,fullWidth:!1,alt:l.title},l.title));export{l as Cta};
//# sourceMappingURL=Cta.js.map
